<template>
  <div>
    <table :class="['no-hover', 'results-theme']" class="hidden-sm-and-down">
      <thead>
        <th v-for="header in headers" :key="header.value">
          {{ header.title }}
        </th>
      </thead>
      <tbody>
        <tr
          v-if="
            disciplineName == 'dressage' || disciplineName == 'paradressage'
          "
        >
          <td class="text-center" data-test="e">
            <div
              v-if="participated && result.resultDetails.judges['e'].percent"
            >
              {{
                dressagePercentFormat(result.resultDetails.judges["e"].percent)
              }}
              <br />
              <i v-if="result.resultDetails.judges['e'].score">
                {{ result.resultDetails.judges["e"].score }} p
                <br />
                ({{ result.resultDetails.judges["e"].rank }})
              </i>
            </div>
          </td>
          <td class="text-center" data-test="h">
            <div
              v-if="participated && result.resultDetails.judges['h'].percent"
            >
              {{
                dressagePercentFormat(result.resultDetails.judges["h"].percent)
              }}
              <br />
              <i v-if="result.resultDetails.judges['h'].score">
                {{ result.resultDetails.judges["h"].score }} p
                <br />
                ({{ result.resultDetails.judges["h"].rank }})
              </i>
            </div>
          </td>
          <td class="text-center" data-test="c">
            <div
              v-if="participated && result.resultDetails.judges['c'].percent"
            >
              {{
                dressagePercentFormat(result.resultDetails.judges["c"].percent)
              }}
              <br />
              <i v-if="result.resultDetails.judges['c'].score">
                {{ result.resultDetails.judges["c"].score }} p
                <br />
                ({{ result.resultDetails.judges["c"].rank }})
              </i>
            </div>
          </td>
          <td class="text-center" data-test="m">
            <div
              v-if="participated && result.resultDetails.judges['m'].percent"
            >
              {{
                dressagePercentFormat(result.resultDetails.judges["m"].percent)
              }}
              <br />
              <i v-if="result.resultDetails.judges['m'].score">
                {{ result.resultDetails.judges["m"].score }} p
                <br />
                ({{ result.resultDetails.judges["m"].rank }})
              </i>
            </div>
          </td>
          <td class="text-center" data-test="b">
            <div
              v-if="participated && result.resultDetails.judges['b'].percent"
            >
              {{
                dressagePercentFormat(result.resultDetails.judges["b"].percent)
              }}
              <br />
              <i v-if="result.resultDetails.judges['b'].score">
                {{ result.resultDetails.judges["b"].score }} p
                <br />
                ({{ result.resultDetails.judges["b"].rank }})
              </i>
            </div>
          </td>
          <td class="text-center">
            <AppShowResultPreview :result="result" />
          </td>
        </tr>
        <tr v-else-if="disciplineName == 'eventing'">
          <td class="text-center">
            <template v-if="participated">
              {{ get(result.resultDetails, "phases.dressage.faults", "-") }}
            </template>
          </td>
          <td class="text-center">
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.crosscountry.obsFaults", "-")
              }}
            </template>
          </td>
          <td class="text-center">
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.crosscountry.timeFaults", "-")
              }}
            </template>
          </td>
          <td class="text-center">
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.showjumping.obsFaults", "-")
              }}
            </template>
          </td>
          <td class="text-center">
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.showjumping.timeFaults", "-")
              }}
            </template>
          </td>
          <td class="text-center">
            <AppShowResultPreview :result="result" />
          </td>
        </tr>
        <tr v-else-if="disciplineName == 'endurance'">
          <td
            v-for="gate in competition.numberOfRounds"
            :key="`g${gate}`"
            class="text-center"
          >
            <EnduranceResultGate
              v-if="participated"
              :result="result"
              :gate="gate"
            />
          </td>
          <td class="text-center">
            <AppShowResultPreview :result="result" />
            <template v-if="participated">
              <i v-if="get(result.resultDetails, 'totalTime')">
                {{ get(result.resultDetails, "totalTime") }}
              </i>
            </template>
          </td>
        </tr>
        <tr v-else-if="disciplineName == 'driving'">
          <td class="text-center" data-test="dressage">
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.dressage.resolution") ==
                "finished"
                  ? get(result.resultDetails, "phases.dressage.score")
                  : roundResolutionI18n(
                      get(result.resultDetails, "phases.dressage.resolution")
                    )
              }}
              <div v-if="get(result.resultDetails, 'phases.dressage.rank')">
                <small
                  ><i
                    >({{
                      get(result.resultDetails, "phases.dressage.rank")
                    }})</i
                  ></small
                >
              </div>
            </template>
          </td>
          <td class="text-center" data-test="cones">
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.cones.resolution") ==
                "finished"
                  ? get(result.resultDetails, "phases.cones.score")
                  : roundResolutionI18n(
                      get(result.resultDetails, "phases.cones.resolution")
                    )
              }}
              <div v-if="get(result.resultDetails, 'phases.cones.rank')">
                <small
                  ><i
                    >({{ get(result.resultDetails, "phases.cones.rank") }})</i
                  ></small
                >
              </div>
            </template>
          </td>
          <td class="text-center" data-test="marathon">
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.marathon.resolution") ==
                "finished"
                  ? get(result.resultDetails, "phases.marathon.score")
                  : roundResolutionI18n(
                      get(result.resultDetails, "phases.marathon.resolution")
                    )
              }}
              <div v-if="get(result.resultDetails, 'phases.marathon.rank')">
                <small
                  ><i
                    >({{
                      get(result.resultDetails, "phases.marathon.rank")
                    }})</i
                  ></small
                >
              </div>
            </template>
          </td>
          <td class="text-center">
            <AppShowResultPreview :result="result" />
          </td>
        </tr>
        <tr v-else-if="disciplineName == 'western'">
          <td class="text-center" data-test="j1">
            <template v-if="participated">
              {{ get(result.resultDetails, "judges.j1.score") }}
            </template>
          </td>
          <td class="text-center" data-test="j2">
            <template v-if="participated">
              {{ get(result.resultDetails, "judges.j2.score") }}
            </template>
          </td>
          <td class="text-center" data-test="j3">
            <template v-if="participated">
              {{ get(result.resultDetails, "judges.j3.score") }}
            </template>
          </td>
          <td class="text-center" data-test="totalScore">
            <template v-if="participated">
              {{ get(result.resultDetails, "totalScore") }}
            </template>
          </td>
          <td class="text-center">
            <AppShowResultPreview :result="result" />
          </td>
        </tr>
        <tr v-else-if="disciplineName == 'vaulting'">
          <VaultingResults :headers="headers" :result="result">
            <template #result>
              <td class="text-center">
                <AppShowResultPreview :result="result" />
              </td>
            </template>
          </VaultingResults>
        </tr>
        <tr v-else-if="disciplineName == 'trec'">
          <td class="text-center" data-test="porScore">
            <template v-if="participated">
              {{ get(result.resultDetails, "porScore") }}
            </template>
          </td>
          <td class="text-center" data-test="maScore">
            <template v-if="participated">
              {{ get(result.resultDetails, "maScore") }}
            </template>
          </td>
          <td class="text-center" data-test="ptvScore">
            <template v-if="participated">
              {{ get(result.resultDetails, "ptvScore") }}
            </template>
          </td>
          <td class="text-center">
            <AppShowResultPreview :result="result" />
          </td>
        </tr>
      </tbody>
    </table>
    <div class="hidden-md-and-up bg-white pa-2" style="font-size: 12px">
      <template
        v-if="disciplineName == 'dressage' || disciplineName == 'paradressage'"
      >
        <v-row>
          <v-col cols="4" class="text-center" data-test="e">
            <strong>{{ $t("events:results.dressage.E.label", "E") }}</strong>
            <div
              v-if="participated && result.resultDetails.judges['e'].percent"
            >
              {{
                dressagePercentFormat(result.resultDetails.judges["e"].percent)
              }}
              <br />
              <i v-if="result.resultDetails.judges['e'].score">
                {{ result.resultDetails.judges["e"].score }} p
                <br />
                ({{ result.resultDetails.judges["e"].rank }})
              </i>
            </div>
          </v-col>
          <v-col cols="4" class="text-center" data-test="h">
            <strong>{{ $t("events:results.dressage.H.label", "H") }}</strong>
            <div
              v-if="participated && result.resultDetails.judges['h'].percent"
            >
              {{
                dressagePercentFormat(result.resultDetails.judges["h"].percent)
              }}
              <br />
              <i v-if="result.resultDetails.judges['h'].score">
                {{ result.resultDetails.judges["h"].score }} p
                <br />
                ({{ result.resultDetails.judges["h"].rank }})
              </i>
            </div>
          </v-col>
          <v-col cols="4" class="text-center" data-test="c">
            <strong>{{ $t("events:results.dressage.C.label", "C") }}</strong>
            <div
              v-if="participated && result.resultDetails.judges['c'].percent"
            >
              {{
                dressagePercentFormat(result.resultDetails.judges["c"].percent)
              }}
              <br />
              <i v-if="result.resultDetails.judges['c'].score">
                {{ result.resultDetails.judges["c"].score }} p
                <br />
                ({{ result.resultDetails.judges["c"].rank }})
              </i>
            </div>
          </v-col>
          <v-col cols="4" class="text-center" data-test="m">
            <strong>{{ $t("events:results.dressage.M.label", "M") }}</strong>
            <div
              v-if="participated && result.resultDetails.judges['m'].percent"
            >
              {{
                dressagePercentFormat(result.resultDetails.judges["m"].percent)
              }}
              <br />
              <i v-if="result.resultDetails.judges['m'].score">
                {{ result.resultDetails.judges["m"].score }} p
                <br />
                ({{ result.resultDetails.judges["m"].rank }})
              </i>
            </div>
          </v-col>
          <v-col cols="4" class="text-center" data-test="b">
            <strong>{{ $t("events:results.dressage.B.label", "B") }}</strong>
            <div
              v-if="participated && result.resultDetails.judges['b'].percent"
            >
              {{
                dressagePercentFormat(result.resultDetails.judges["b"].percent)
              }}
              <br />
              <i v-if="result.resultDetails.judges['b'].score">
                {{ result.resultDetails.judges["b"].score }} p
                <br />
                ({{ result.resultDetails.judges["b"].rank }})
              </i>
            </div>
          </v-col>
        </v-row>
        <v-col class="text-center">
          <strong>{{ $t("events:results.Total.label", "Total") }}</strong>
          <br />
          <AppShowResultPreview :result="result" />
        </v-col>
      </template>
      <template v-else-if="disciplineName == 'eventing'">
        <v-row>
          <v-col cols="4" class="text-center">
            <strong>{{
              $t("events:results.EventingDressage.label", "D")
            }}</strong>
            <br />
            <template v-if="participated">
              {{ get(result.resultDetails, "phases.dressage.faults", "-") }}
            </template>
          </v-col>
          <v-col cols="4" class="text-center">
            <strong>{{
              $t("events:results.EventingXCObst.label", "XC Obs")
            }}</strong>
            <br />
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.crosscountry.obsFaults", "-")
              }}
            </template>
          </v-col>
          <v-col cols="4" class="text-center">
            <strong>{{
              $t("events:results.EventingXCTime.label", "XC Time")
            }}</strong>
            <br />
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.crosscountry.timeFaults", "-")
              }}
            </template>
          </v-col>
          <v-col cols="4" class="text-center">
            <strong>{{
              $t("events:results.EventingJObst.label", "J Obs")
            }}</strong>
            <br />
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.showjumping.obsFaults", "-")
              }}
            </template>
          </v-col>
          <v-col cols="4" class="text-center">
            <strong>{{
              $t("events:results.EventingJTime.label", "J Time")
            }}</strong>
            <br />
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.showjumping.timeFaults", "-")
              }}
            </template>
          </v-col>
        </v-row>
        <v-col class="text-center">
          <strong>{{
            $t("events:results.EventingResults.label", "Result")
          }}</strong>
          <br />
          <AppShowResultPreview :result="result" />
        </v-col>
      </template>
      <template v-else-if="disciplineName == 'endurance'">
        <v-row>
          <template v-if="participated">
            <v-col
              v-for="gate in competition.numberOfRounds"
              :key="`g${gate}`"
              class="text-center"
              cols="3"
            >
              <strong>{{
                $t(`events:results.Endurance.Gate${gate}.label`, `Gate ${gate}`)
              }}</strong>
              <br />
              <EnduranceResultGate :result="result" :gate="gate" />
            </v-col>
          </template>
        </v-row>
        <v-col class="text-center">
          <strong>{{
            $t("events:results.Endurance.Result.label", "Result")
          }}</strong>
          <br />
          <AppShowResultPreview :result="result" />
          <template v-if="participated">
            <i v-if="get(result.resultDetails, 'totalTime')">
              {{ get(result.resultDetails, "totalTime") }}
            </i>
          </template>
        </v-col>
      </template>
      <template v-else-if="disciplineName == 'driving'">
        <v-row>
          <v-col class="text-center" data-test="dressage">
            <strong>{{
              $t("events:results.Driving.ShortforDressage.label", "D")
            }}</strong>
            <br />
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.dressage.resolution") ==
                "finished"
                  ? get(result.resultDetails, "phases.dressage.score")
                  : roundResolutionI18n(
                      get(result.resultDetails, "phases.dressage.resolution")
                    )
              }}
              <div v-if="get(result.resultDetails, 'phases.dressage.rank')">
                <small
                  ><i
                    >({{
                      get(result.resultDetails, "phases.dressage.rank")
                    }})</i
                  ></small
                >
              </div>
            </template>
          </v-col>
          <v-col class="text-center" data-test="cones">
            <strong>{{
              $t("events:results.Driving.ShortforCones.label", "C")
            }}</strong>
            <br />
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.cones.resolution") ==
                "finished"
                  ? get(result.resultDetails, "phases.cones.score")
                  : roundResolutionI18n(
                      get(result.resultDetails, "phases.cones.resolution")
                    )
              }}
              <div v-if="get(result.resultDetails, 'phases.cones.rank')">
                <small
                  ><i
                    >({{ get(result.resultDetails, "phases.cones.rank") }})</i
                  ></small
                >
              </div>
            </template>
          </v-col>
          <v-col class="text-center" data-test="marathon">
            <strong>{{
              $t("events:results.Driving.ShortforMarathon.label", "M")
            }}</strong>
            <br />
            <template v-if="participated">
              {{
                get(result.resultDetails, "phases.marathon.resolution") ==
                "finished"
                  ? get(result.resultDetails, "phases.marathon.score")
                  : roundResolutionI18n(
                      get(result.resultDetails, "phases.marathon.resolution")
                    )
              }}
              <div v-if="get(result.resultDetails, 'phases.marathon.rank')">
                <small
                  ><i
                    >({{
                      get(result.resultDetails, "phases.marathon.rank")
                    }})</i
                  ></small
                >
              </div>
            </template>
          </v-col>
        </v-row>
        <v-col class="text-center">
          <strong>{{
            $t("events:results.Driving.Result.label", "Result")
          }}</strong
          ><br />
          <AppShowResultPreview :result="result" />
        </v-col>
      </template>
      <template v-else-if="disciplineName == 'western'">
        <v-row>
          <v-col class="text-center" data-test="j1">
            <strong>{{
              $t("events:results.Western.Judge1.label", "J1")
            }}</strong>
            <br />
            <template v-if="participated">
              {{ get(result.resultDetails, "judges.j1.score") }}
            </template>
          </v-col>
          <v-col class="text-center" data-test="j2">
            <strong>{{
              $t("events:results.Western.Judge2.label", "J2")
            }}</strong>
            <br />
            <template v-if="participated">
              {{ get(result.resultDetails, "judges.j2.score") }}
            </template>
          </v-col>
          <v-col class="text-center" data-test="j3">
            <strong>{{
              $t("events:results.Western.Judge3.label", "J3")
            }}</strong>
            <br />
            <template v-if="participated">
              {{ get(result.resultDetails, "judges.j3.score") }}
            </template>
          </v-col>
          <v-col class="text-center" data-test="totalScore">
            <strong>{{
              $t("events:results.Western.Total.label", "Total")
            }}</strong>
            <br />
            <template v-if="participated">
              {{ get(result.resultDetails, "totalScore") }}
            </template>
          </v-col>
        </v-row>
        <v-col class="text-center">
          <strong>{{
            $t("events:results.Western.Average.label", "Average")
          }}</strong>
          <br />
          <AppShowResultPreview :result="result" />
        </v-col>
      </template>
      <template v-else-if="disciplineName == 'vaulting'">
        <v-row justify="center">
          <VaultingResults :headers="headers" :result="result" mobile />
        </v-row>
        <v-col v-if="!result.overrideResultDisplayText" class="text-center">
          {{ $t("events:results.Vaulting.Result.label", "Result") }}
          <AppShowResultPreview :result="result" />
        </v-col>
      </template>
      <template v-else-if="disciplineName == 'trec'">
        <v-row>
          <v-col class="text-center" data-test="porScore">
            <strong>{{
              $t("events:common.results.TREC.POR.field", "P.O.R.")
            }}</strong>
            <br />
            <template v-if="participated">
              {{ get(result.resultDetails, "porScore") }}
            </template>
          </v-col>
          <v-col class="text-center" data-test="maScore">
            <strong>{{
              $t("events:common.results.TREC.MA.field", "M.A.")
            }}</strong>
            <br />
            <template v-if="participated">
              {{ get(result.resultDetails, "maScore") }}
            </template>
          </v-col>
          <v-col class="text-center" data-test="ptvScore">
            <strong>{{
              $t("events:common.results.TREC.PTV.field", "P.T.V.")
            }}</strong>
            <br />
            <template v-if="participated">
              {{ get(result.resultDetails, "ptvScore") }}
            </template>
          </v-col>
          <v-col class="text-center">
            <strong>{{
              $t("events:common.results.TREC.finalScore.field", "Final score")
            }}</strong>
            <br />
            <AppShowResultPreview :result="result" />
          </v-col>
        </v-row>
      </template>
    </div>
  </div>
</template>
<script>
import gql from "fraql";
import { get } from "lodash-es";
import { useDisciplineResultsHeader } from "@elements/DisciplineResults/disciplineResultsHeader";
import dressagePercentFormat from "@/utils/dressagePercentFormat.js";
import { useRoundResolutionHelper } from "@composables/round_resolutions";
import VaultingResults from "@elements/DisciplineResults/VaultingResults.js";
import AppShowResultPreview from "@AppShows/AppShowResultPreview.vue";
import EnduranceResultGate from "@elements/DisciplineResults/EnduranceResultGate.vue";
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "AppShowLongResults",
  components: { AppShowResultPreview, VaultingResults, EnduranceResultGate },
  props: {
    result: {
      type: Object,
      required: true
    },
    disciplineName: {
      type: String,
      required: true
    },
    noTheme: {
      type: Boolean,
      default: false
    },
    competition: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { disciplineResultsHeader } = useDisciplineResultsHeader();
    const { roundResolutionI18n } = useRoundResolutionHelper();

    const headers = computed(() => {
      return disciplineResultsHeader(props.disciplineName, props.competition, [
        props.result
      ]);
    });

    return {
      roundResolutionI18n,
      dressagePercentFormat,
      headers,
      get
    };
  },
  computed: {
    participated() {
      return this.result.resolution == "participated";
    }
  },
  fragments: {
    resultFields: gql`
      fragment _ on Result {
        id
        resultDetails
        overrideResultDisplayText
      }
    `,
    competition: gql`
      fragment _ on Competition {
        id
        numberOfRounds
      }
    `
  }
});
</script>
<style lang="scss" scoped>
.results-theme {
  tbody tr:hover:not(.v-data-table__expanded__content) {
    background: white !important;
    th {
      font-weight: bold !important;
      text-align: center !important;
    }
    td {
      text-align: center !important;
    }
  }
}
</style>
